module.exports = __webpack_public_path__ + "dist/media/ec_comp_select.9cef5960.svg";